import { Component, OnInit } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { LuckyNumberService } from "src/app/services/lucky-number.service";
const isEmpty = (val: Data) => val === null || !(Object.keys(val) || val).length;

@Component({
  selector: "app-pick-gold-rings",
  templateUrl: "./pick-gold-rings.component.html",
  styleUrls: ["./pick-gold-rings.component.scss"],
})
export class PickGoldRingsComponent implements OnInit {
  goldRingsOnBoardData: Data;
  private goldRingsDataSubscription: Subscription | undefined;
  constructor(
    private authService: AuthService,
    public translate: TranslateService,
    private luckyNumberService: LuckyNumberService,
    private bottomSheet: MatBottomSheet
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {
    try {
      const goldRings = "gold_rings";
      this.goldRingsDataSubscription = this.luckyNumberService
        .getOnboardData(goldRings)
        .subscribe((onBoardRef: Data) => {
          if (onBoardRef?.exists && !isEmpty(onBoardRef?.data())) {
            this.goldRingsOnBoardData = onBoardRef?.data()?.gold_rings?.page_1;
          }
        });
    } catch (err) {
      return err;
    }
  }

  pickGoldRings() {
    try {
      this.bottomSheet.dismiss(); // dismiss the bottom sheet when clicked on CTA.
    } catch (err) {
      return err;
    }
  }

  ngOnDestroy() {
    this.goldRingsDataSubscription.unsubscribe();
  }
}
